<div style="float: left; margin-bottom: 2rem; margin-top: 1rem">
  <button (click)="openCreateVideoDialog()" color="primary"
          mat-raised-button>{{ 'Inserto youtube url' | translate }}</button>
</div>

<table [dataSource]="videos" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="url">
    <th *matHeaderCellDef mat-header-cell> {{ 'Url' | translate }}</th>
    <td *matCellDef="let video" mat-cell> {{video.youtubeUrl}} </td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th *matHeaderCellDef mat-header-cell> {{ 'Data krijimit' | translate }}</th>
    <td *matCellDef="let video" mat-cell> {{ video.createdAt | date:'dd/MM/yyyy HH:mm' }} </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th *matHeaderCellDef mat-header-cell> {{ 'Edit' | translate }} </th>
    <td *matCellDef="let video" mat-cell>
      <a (click)="openEditVideoDialog(video)" style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }} </th>
    <td *matCellDef="let video" mat-cell>
      <a (click)="deleteVideo(video.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>

